import React from "react";

export default function Description({ PropertyObject }) {
  return (<>
    {
      PropertyObject.PropertyDescription ? (<>
        {" "}
        <h5 className="fw-6 title">Description</h5>
        <div className="text-variant-1"
          dangerouslySetInnerHTML={{ __html: PropertyObject.PropertyDescription ? PropertyObject.PropertyDescription : "" }}
        >
        </div>
        {/* <p className="mt-8 text-variant-1">
          An ideal choice for sports and leisure enthusiasts who will be able to
          take advantage of its swimming pool (11m x 5m), tennis court, gym and
          sauna.
        </p>
        <a href="#" className="btn-view">
          <span className="text">View More</span>
        </a> */}
      </>
      ) : null
    }
  </>

  );
}
